<template>
	<div class="searchKeywords">
		<div class="searchKeywords__inner container">
			<form v-on:submit.prevent="searchSubmit" class="formSearch">

				<div class="row">
					<!--<div v-bind:class="{'hidden-xs': isPageFlg}" class="col-xs-4 col-sm-2 col-sm-offset-2">
						<template v-if="isPageFlg">
						<div class="toggle_advancedSearch" data-toggle="collapse" data-target="#advancedSearch">
							<a class="linkTrriger"><i class="glyphicon glyphicon-triangle-bottom"></i> 条件で検索</a>
						</div>
						</template>
						<template v-else>
						<div class="toggle_advancedSearch">
							<a v-on:click="smoothScroll('#advancedSearch')" class="linkTrriger"><i class="glyphicon glyphicon-triangle-bottom"></i> 条件で検索</a>
						</div>
						</template>
					</div>-->

					<div v-bind:class="{'col-xs-offset-2': xsflg}" class="searchKeywords__inputGroup col-xs-8 col-sm-4  col-sm-push-6">
						<div class="input-group">
							<input v-bind:value="w" v-on:input="updateSearchWords" type="text" class="searchKeywords__input form-control" placeholder="キーワードで検索">
							<span class="input-group-btn">
								<button v-if="xsflg" v-on:click="collapseHide" v-on:click.prevent="searchSubmit" v-on:click="smoothScroll('body')" class="searchKeywords__submit btn" data-target="#searchBlock"><span class="glyphicon glyphicon-search"></span></button>
								<button v-else v-on:click="collapseHide" v-on:click.prevent="searchSubmit" v-on:click="smoothScroll('body')" class="searchKeywords__submit btn" data-target="#advancedSearch"><span class="glyphicon glyphicon-search"></span></button>
							</span>
						</div>
					</div>
					<div class="col-xs-12 col-sm-6 col-sm-pull-4">
						<ul class="searchKeywords__trendWards">
							<li><a v-on:click="searchWordLink('24時間')" class="linkTrriger">24時間</a></li>
							<li><a v-on:click="searchWordLink('芝生')" class="linkTrriger">芝生</a></li>
							<li><a v-on:click="searchWordLink('プール')" class="linkTrriger">プール</a></li>
							<li><a v-on:click="searchWordLink('階段')" class="linkTrriger">階段</a></li>
						</ul>
					</div>
				</div>
				<!-- <div class="hidden_isPage row">
					<div class="col-xs-12">
						<ul class="searchKeywords__trendWards list-inline">
							<li><a v-on:click="smoothScroll('#as1')" class="linkTrriger">スタジオタイプ</a></li>
							<li><a v-on:click="smoothScroll('#as2')" class="linkTrriger">広さ・料金</a></li>
							<li><a v-on:click="smoothScroll('#as3')" class="linkTrriger">所在地</a></li>
							<li><a v-on:click="smoothScroll('#as4')" class="linkTrriger">設備・雰囲気</a></li>
						</ul>
					</div>
				</div> -->

			</form>
		</div>
	</div>
</template>

<script>
import { searchWords, searchWordsLink, searchConditions, radio, checkbox, areacode, SCStr, reset } from '../vuex/actions';
import { getSearchWords, getSearchConditions, getChecked, getSliderValue, getPrefecturesList, getDistrict, getAreaCode, getSituation, getFacility, getService } from '../vuex/getters';
module.exports = {
	vuex: {
		getters: {
			w: getSearchWords,
			c: getSearchConditions,
			checked: getChecked,
			sliderValue: getSliderValue,
			prefecturesList: getPrefecturesList,
			district: getDistrict,
			areaCode: getAreaCode,
			situation: getSituation,
			facility: getFacility,
			service: getService
		},
		actions: {
			updateSearchWords: searchWords,
			updateSearchWordsLink: searchWordsLink,
			updateSearchConditions: searchConditions,
			updateRadio: radio,
			updateCheckbox: checkbox,
			setAreaCode: areacode,
			setSCStr: SCStr,
			conditionReset: reset
		}
	},
	props: {
		xsflg: ''
	},
	data: function(){
		return {
			pageTitle: '検索結果',
			q: ''
		};
	},
	ready: function(){
	},
	methods: {
		collapseHide: function(e){
			var target = e.currentTarget.getAttribute('data-target');
			$(target).collapse('hide');
		}
	},
	computed: {
		isPageFlg: function(){
			return this.$route.isPage;
		}
	},
	mixins: [
		require('../mixins/getPrefectures.js'),
		require('../mixins/searchSubmit.js'),
		require('../mixins/searchWordLink.js'),
		require('../mixins/smoothScroll.js')
	]
};
</script>

<style scoped lang="scss">
.searchBlock .searchButton a{
	cursor: pointer;
}
.btn_submit{
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// searchwords.vue?54bd8e66